import { useEffect, useRef } from 'react';
import { dashboardMapEventsService } from '@/events/dashboardMap.subject';
import type { DashboardMapEvent } from '@/events/dashboardMapEvents';

export type { DashboardMapEvent } from '@/events/dashboardMapEvents';

export interface DashboardMapEventHandlers {
	onChangeAnimation: (run: boolean) => void;
	onSetMode: (mode: string) => void;
	onResetDma: () => void;
	onCleanRainfallLayer: () => void;
	onDrawRainfallLayer: (futureRainfall: boolean) => void;
	onFutureRainfallToggleChanged: (futureRainfall: boolean) => void;
	onClosePopup: () => void;
	onZoomToAsset: (infrastructureId?: number | string) => void;
}

export function useDashboardMapEvents(handlers: DashboardMapEventHandlers) {
	const handlersRef = useRef(handlers);
	handlersRef.current = handlers;

	useEffect(() => {
		const subscription = dashboardMapEventsService.getSubject().subscribe((mapEvent: DashboardMapEvent) => {
			switch (mapEvent.type) {
				case 'changeAnimation':
					handlersRef.current.onChangeAnimation(mapEvent.data);
					break;
				case 'setMode':
					handlersRef.current.onSetMode(mapEvent.data);
					break;
				case 'resetDma':
					handlersRef.current.onResetDma();
					break;
				case 'cleanRainfallLayer':
					handlersRef.current.onCleanRainfallLayer();
					break;
				case 'drawRainfallLayer':
					handlersRef.current.onDrawRainfallLayer(mapEvent.data.futureRainfall);
					break;
				case 'futureRainfallToggleChanged':
					handlersRef.current.onFutureRainfallToggleChanged(mapEvent.data.futureRainfall);
					break;
				case 'closePopup':
					handlersRef.current.onClosePopup();
					break;
				case 'zoomToAsset':
					handlersRef.current.onZoomToAsset(mapEvent.data?.infrastructureId);
					break;
			}
		});
		return () => {
			subscription.unsubscribe();
		};
	}, []);
}
